import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, createStaticVNode as _createStaticVNode } from "vue"
import _imports_0 from '../../assets/Images/Videos/Video-Residential.mp4'
import _imports_1 from '../../assets/Images/Videos/Video-Investment.mp4'
import _imports_2 from '../../assets/Images/logo02.png'
import _imports_3 from '../../assets/Images/img-welcome.png'


const _hoisted_1 = { class: "hidden-mobile" }
const _hoisted_2 = { class: "realtors-target" }
const _hoisted_3 = { class: "container-fixed" }
const _hoisted_4 = {
  class: "modal fade",
  id: "modalProducts",
  tabindex: "-1",
  "aria-labelledby": "exampleModalLabel",
  "aria-hidden": "true"
}
const _hoisted_5 = { class: "modal-dialog modal-xl" }
const _hoisted_6 = { class: "modal-content" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("div", { class: "modal-header" }, [
  /*#__PURE__*/_createElementVNode("button", {
    type: "button",
    class: "btn-close custom-close-button",
    "data-bs-dismiss": "modal",
    "aria-label": "Close"
  }, [
    /*#__PURE__*/_createElementVNode("i", { class: "fas fa-times" })
  ])
], -1)
const _hoisted_8 = {
  key: 0,
  class: "modal-body"
}
const _hoisted_9 = { key: 0 }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("video", {
  src: _imports_0,
  class: "tw-w-full",
  controls: "",
  autoplay: ""
}, null, -1)
const _hoisted_11 = [
  _hoisted_10
]
const _hoisted_12 = { key: 1 }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("video", {
  src: _imports_1,
  class: "tw-w-full",
  controls: "",
  autoplay: ""
}, null, -1)
const _hoisted_14 = [
  _hoisted_13
]
const _hoisted_15 = { class: "realtors-target__navbar" }
const _hoisted_16 = { class: "navbar navbar-expand-lg d-flex justify-content-between" }
const _hoisted_17 = {
  class: "collapse navbar-collapse d-flex justify-content-between",
  id: "navbarTogglerDemo01"
}
const _hoisted_18 = /*#__PURE__*/_createElementVNode("a", {
  class: "navbar-brand",
  href: "/"
}, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_2,
    alt: ""
  })
], -1)
const _hoisted_19 = { class: "form-inline my-2 my-lg-0" }
const _hoisted_20 = { class: "navbar-nav mr-auto mt-2 mt-lg-0 d-flex align-items-center" }
const _hoisted_21 = { class: "nav-item active tw-pr-[40px]" }
const _hoisted_22 = { class: "nav-item active tw-pr-[26px] tw-pl-[2px]" }
const _hoisted_23 = { class: "nav-item active pr-4 tw-relative" }
const _hoisted_24 = { class: "dropdown tw-block tw-relative" }
const _hoisted_25 = /*#__PURE__*/_createElementVNode("a", {
  class: "tw-bg-transparent tw-text-[#606060] tw-flex tw-justify-between tw-w-[150px] tw-items-center",
  type: "button",
  "data-bs-toggle": "dropdown",
  "aria-expanded": "false"
}, [
  /*#__PURE__*/_createTextVNode(" PRODUCTS "),
  /*#__PURE__*/_createElementVNode("i", { class: "fas fa-caret-down tw-pb-0.5" })
], -1)
const _hoisted_26 = { class: "dropdown-menu" }
const _hoisted_27 = { class: "nav-item tw-pr-[45px] tw-pl-[30px]" }
const _hoisted_28 = { class: "nav-item dropdown" }
const _hoisted_29 = /*#__PURE__*/_createElementVNode("a", {
  class: "nav-link dropdown-toggle",
  href: "#",
  id: "navbarDropdownMenuLink",
  role: "button",
  "data-bs-toggle": "dropdown",
  "aria-expanded": "false"
}, " SIGN UP ", -1)
const _hoisted_30 = {
  class: "dropdown-menu",
  "aria-labelledby": "navbarDropdownMenuLink"
}
const _hoisted_31 = ["href"]
const _hoisted_32 = /*#__PURE__*/_createStaticVNode("<div class=\"realtors-tools tw-bg-[#fff] tw-pt-10 tw-drop-shadow-2xl\"><div class=\"container\"><div class=\"hidden-mobile\"><div class=\"tw-flex tw-justify-center\"><div><video class=\"tw-mt-[20px]\" src=\"https://www.realtortools.org/media/Video-MLO-tutorial.mp4\" width=\"800\" height=\"400\" poster=\"" + _imports_3 + "\" controls></video></div></div></div><div class=\"visible-mobile\"><div class=\"d-flex tw-justify-center\"><div class=\"content-videos\"><div class=\"welcome\"><video class=\"tw-mt-[20px]\" src=\"https://www.realtortools.org/media/Video-MLO-tutorial.mp4\" width=\"350\" height=\"250\" poster=\"" + _imports_3 + "\" controls></video></div></div></div></div></div></div>", 1)
const _hoisted_33 = { class: "footer-realtors" }
const _hoisted_34 = { class: "container-fixed" }
const _hoisted_35 = { class: "row w-100" }
const _hoisted_36 = /*#__PURE__*/_createStaticVNode("<div class=\"img-brand col-xs-12 col-sm-12 col-md-3\"><img src=\"" + _imports_2 + "\" alt=\"\"></div><div class=\"contact col-xs-12 col-sm-12 col-md-3\"><ul class=\"\"><li class=\"tw-pb-3\"><a href=\"#\" class=\"fs-4 tw-font-semibold\">Contact</a></li><li class=\"tw-mb-4 tw-pt-3\"><a href=\"/contact/realtor\" class=\"tw-font-normal tw-text-[#dfdede] tw-ml-5\">Related to Realtor</a></li><li class=\"tw-mb-4 tw-pt-3\"><a href=\"/contact/mlo\" class=\"tw-text-[#dfdede] tw-ml-5\">Related to MLO</a></li><li class=\"tw-mb-4 tw-pt-3\"><a href=\"/contact/title-company\" class=\"tw-text-[#dfdede] tw-ml-5\">Related to Title Company</a></li><li class=\"tw-mb-4 tw-pt-3\"><a href=\"/contact/inspector\" class=\"tw-text-[#dfdede] tw-ml-5\">Related to Inspectors</a></li></ul></div>", 2)
const _hoisted_38 = { class: "documents col-xs-12 col-sm-12 col-md-3" }
const _hoisted_39 = { class: "" }
const _hoisted_40 = { class: "tw-mb-4 tw-pt-3 fs-5 tw-font-semibold" }
const _hoisted_41 = /*#__PURE__*/_createStaticVNode("<li class=\"tw-mb-4 tw-pt-3\"><a href=\"https://www.realtortools.org/media/REALTORTOLLS-POLICY-ENGLISH.pdf\" class=\"fs-5 tw-font-semibold\" target=\"_blank\">Privacy Policy</a></li><li class=\"tw-mb-4 tw-pt-3\"><a href=\"https://www.realtortools.org/media/TERMS-AND-USES.pdf\" class=\"fs-5 tw-font-semibold\" target=\"_blank\">Terms of use</a></li><li class=\"tw-mb-4 tw-pt-3\"><a href=\"https://www.realtortools.org/media/COPYRIGHT-HOME.pdf\" class=\"fs-5 tw-font-semibold\" target=\"_blank\">Copyright</a></li>", 3)
const _hoisted_44 = /*#__PURE__*/_createElementVNode("hr", null, null, -1)
const _hoisted_45 = /*#__PURE__*/_createElementVNode("div", { class: "hidden-mobile" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "footer-realtors__section5__copyright pb-5" }, [
    /*#__PURE__*/_createElementVNode("span", null, "© 2023 SOURCE RealtorTools, PBC. All rights reserved. Terms of Use | Privacy Policy Patents")
  ])
], -1)
const _hoisted_46 = /*#__PURE__*/_createElementVNode("div", { class: "visible-mobile" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "footer-realtors__section5__copyright pb-5" }, [
    /*#__PURE__*/_createElementVNode("span", null, [
      /*#__PURE__*/_createTextVNode("© 2023 SOURCE RealtorTools, PBC. "),
      /*#__PURE__*/_createElementVNode("br"),
      /*#__PURE__*/_createTextVNode(" All rights reserved. "),
      /*#__PURE__*/_createElementVNode("br"),
      /*#__PURE__*/_createTextVNode(" Terms of Use | Privacy Policy Patents")
    ])
  ])
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_routerLink = _resolveComponent("routerLink")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("div", _hoisted_6, [
                _hoisted_7,
                (_ctx.productSelected)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                      (_ctx.productSelected.toString() == '1')
                        ? (_openBlock(), _createElementBlock("div", _hoisted_9, _hoisted_11))
                        : _createCommentVNode("", true),
                      (_ctx.productSelected.toString() == '2')
                        ? (_openBlock(), _createElementBlock("div", _hoisted_12, _hoisted_14))
                        : _createCommentVNode("", true)
                    ]))
                  : _createCommentVNode("", true)
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_15, [
            _createElementVNode("nav", _hoisted_16, [
              _createElementVNode("div", _hoisted_17, [
                _hoisted_18,
                _createElementVNode("form", _hoisted_19, [
                  _createElementVNode("ul", _hoisted_20, [
                    _createElementVNode("li", _hoisted_21, [
                      _createVNode(_component_routerLink, { to: "/" }, {
                        default: _withCtx(() => [
                          _createTextVNode("HOME")
                        ]),
                        _: 1
                      })
                    ]),
                    _createElementVNode("li", _hoisted_22, [
                      _createVNode(_component_routerLink, { to: "/target" }, {
                        default: _withCtx(() => [
                          _createTextVNode("TARGET")
                        ]),
                        _: 1
                      })
                    ]),
                    _createElementVNode("li", _hoisted_23, [
                      _createElementVNode("a", _hoisted_24, [
                        _hoisted_25,
                        _createElementVNode("ul", _hoisted_26, [
                          _createElementVNode("li", null, [
                            _createElementVNode("a", {
                              class: "dropdown-item",
                              href: "#",
                              onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.openModal('modalProducts', '1')))
                            }, "RESIDENTIAL")
                          ]),
                          _createElementVNode("li", null, [
                            _createElementVNode("a", {
                              class: "dropdown-item",
                              href: "#",
                              onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.openModal('modalProducts', '2')))
                            }, "INVESTMENT")
                          ])
                        ])
                      ])
                    ]),
                    _createElementVNode("li", _hoisted_27, [
                      _createVNode(_component_routerLink, { to: "/loginusers" }, {
                        default: _withCtx(() => [
                          _createTextVNode("LOG IN ")
                        ]),
                        _: 1
                      })
                    ]),
                    _createElementVNode("li", _hoisted_28, [
                      _hoisted_29,
                      _createElementVNode("ul", _hoisted_30, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.listRoles, (role) => {
                          return (_openBlock(), _createElementBlock(_Fragment, null, [
                            (role.name != 'ADMIN')
                              ? (_openBlock(), _createElementBlock("a", {
                                  key: 0,
                                  class: "dropdown-item",
                                  id: "option",
                                  href: '/register?type=' + role.idRole
                                }, _toDisplayString(role.name), 9, _hoisted_31))
                              : _createCommentVNode("", true)
                          ], 64))
                        }), 256))
                      ])
                    ])
                  ])
                ])
              ])
            ])
          ])
        ])
      ])
    ]),
    _hoisted_32,
    _createElementVNode("div", _hoisted_33, [
      _createElementVNode("div", _hoisted_34, [
        _createElementVNode("div", _hoisted_35, [
          _hoisted_36,
          _createElementVNode("div", _hoisted_38, [
            _createElementVNode("ul", _hoisted_39, [
              _createElementVNode("li", _hoisted_40, [
                _createVNode(_component_routerLink, { to: "/faqs" }, {
                  default: _withCtx(() => [
                    _createTextVNode("FAQs")
                  ]),
                  _: 1
                })
              ]),
              _hoisted_41
            ])
          ])
        ]),
        _hoisted_44,
        _hoisted_45,
        _hoisted_46
      ])
    ])
  ], 64))
}